// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import VueSocketIO from 'vue-socket.io'




import store from './store'

import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

import Moment from "moment"
import Vant from 'vant';
import 'vant/lib/index.css';

import { NumberKeyboard } from 'vant';

Vue.use(NumberKeyboard);

Vue.use(Vant);

Vue.filter("formatDate", function(value) {
    return Moment(value).format("YYYY-MM-DD HH:mm:ss")
})

import MuseUI from 'muse-ui';
import 'muse-ui/dist/muse-ui.css';


Vue.use(MuseUI)

Vue.use(MintUI, {
    lazyload: {
        preLoad: 0,
        loading: 'https://www.4xj.me/static/icons/grey.gif',
        error: 'https://i.loli.net/2018/07/14/5b49afc0f40ae.jpg',
    }
})

Vue.use(new VueSocketIO({
    debug: true,
    connection: chat_url,
    vuex: {
        store: store,
        actionPrefix: 'SOCKET_',
        mutationPrefix: 'SOCKET_'
    },
    options: { secure: true, transports: ['websocket'] }
}));

Vue.config.productionTip = false



window.$store = store;
window.$router = router






/* eslint-disable no-new */
let vueobj = new Vue({

    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})
window.$vue = vueobj;
/*
setTimeout(()=>{
    store.dispatch("initAppConfig")
},3000);
*/
setTimeout(() => {
    window.loading.style.display = "none";
}, 1500);
store.dispatch("getTickers")
store.dispatch("getConfig")
store.dispatch("getProlist")


// WEBPACK FOOTER //
// ./src/main.js